import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import './assets/css/global.css';
import './assets/css/reset.css';
import Loading from './components/global/Loading';
import Routers from './page/router/Routers';

function App() {
  const [cursorPosition, setCursorPosition] = useState({ left: 0, top: 0 });
  const [isSizeUp, setIsSizeUp] = useState(false);
  const isLoading = useRef(true);
  const open = useSelector((state) => state.open.boolean);
  const theme = useSelector((state) => state.header.theme);

  const handleMouseMove = (e) => {
    setCursorPosition({ left: e.clientX, top: e.clientY });
  };
  useEffect(() => {
    const mouseCursor = document.querySelector(".cursor");
    const mouseClass = document.querySelector(".hovered-link");
    if (mouseClass) {
      mouseCursor.classList.add("sizeUp");
      setIsSizeUp(true);
    } else {
      mouseCursor.classList.remove("sizeUp");
      setIsSizeUp(false);
    }
  }, [handleMouseMove]);

  useEffect(() => {
    const hideLoading = setTimeout(() => {
      isLoading.current = false;
    }, 2000);

    return () => {
      clearTimeout(hideLoading);
    }
  }, []);


  const cursorStyle = {
    left: cursorPosition.left,
    top: cursorPosition.top,
    borderColor: open ? theme : 'white',
    backgroundColor: isSizeUp ? 'white' : 'transparent',
  };

  return (
    <div onMouseMove={handleMouseMove}>
      {isLoading.current && <Loading />}
      <div className="cursor" style={cursorStyle}>{isSizeUp && <span></span>}
        {/* <BsTriangle style={{color:theme}}/> */}
      </div>
      <Routers />
    </div>

  );
}

export default App;
